import React from "react";
import axios from "axios";
import classNames from "classnames";

import Modal from "../Modal";
import FormField from "../FormUi/FormField";
import FormSelect from "../FormUi/FormSelect";
import PropTypes from "prop-types";
import { DATETIME } from "../../utils/dateFormats";

class ChatroomFormModal extends React.Component {
  state = {
    loading: false,
    errors: {},
    users: this.props.selectedChatroomUsers ? this.props.selectedChatroomUsers.map(chatroomUser => ({
      id: chatroomUser.user_id,
      label: `${chatroomUser.first_name} ${chatroomUser.last_name}`,
      value: chatroomUser.user_id
    })) : [],
    title: this.props.chatroom ? this.props.chatroom.title : "",
    locationId: this.props.chatroom ? this.props.chatroom.location_id : null,
    positionId: this.props.chatroom ? this.props.chatroom.position_id : null,
    chatroomType: this.props.chatroom ? this.props.chatroom.chatroom_type : 0,
    repliesEnabled: this.props.chatroom ? this.props.chatroom.replies_enabled : true
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.selectedChatroomUsers != nextProps.selectedChatroomUsers) {
      this.setState({
        users: nextProps.selectedChatroomUsers.map(chatroomUser => ({
          id: chatroomUser.user_id,
          label: `${chatroomUser.first_name} ${chatroomUser.last_name}`,
          value: chatroomUser.user_id
        })),
      })
    };
    if (this.props.newChatroom) {
      this.setState({
        locationId: nextProps.locationId,
        positionId: nextProps.positionId
      })
    }
    if (this.props.chatroom != nextProps.chatroom) {
      this.setState({
        title: nextProps.chatroom.title,
        locationId: nextProps.chatroom.location_id,
        positionId: nextProps.chatroom.position_id,
        chatroomType: nextProps.chatroom.chatroom_type,
        repliesEnabled: nextProps.chatroom.replies_enabled
      })
    };
  }

  render() {
    const {
      users, title, errors, loading, location, position
    } = this.state;

    const {
      visible, userOptions,locationOptions, positionOptions
    } = this.props;

    return (
      <div>
        <Modal
          title={this.props.title}
          subTitle={this.chatroomSubTitle()}
          visible={visible}
          onClose={this.props.handlerToggleModal}
          skipInitialClose={true}
        >
          <div>
            <form onSubmit={this.submit}>
              <FormField
                type="text"
                label="Title"
                placeholder="Title"
                name="title"
                value={this.state.title}
                required={true}
                errors={this.state.errors.title}
                onChange={this.handlerChangeTitle}
              />
              <FormSelect
                _key="value"
                _val="label"
                label="Chat Replies"
                name="replies_enabled"
                selectId="chat-modal-select-replies-enabled"
                required={true}
                selectProps={{isMulti: false}}
                errors={errors.replies_enabled}
                value={this.state.repliesEnabled}
                options={[
                  { value: false, label: "Disabled" },
                  { value: true, label: "Enabled" }
                ]}
                onChange={this.handlerChangeRepliesEnabled}
                skipSelect={true}
                styles={{
                  placeholder: (base) => ({
                    ...base,
                    color: "#555",
                  }),
                }}
              />
              {this.props.newChatroom && (
                <div>
                  <FormSelect
                    _key="id"
                    _val="type"
                    label="Chat Type"
                    name="chatroom_type"
                    selectId="chat-modal-select-chat-type"
                    required={true}
                    selectProps={{isMulti: false}}
                    errors={errors.chatroom_type}
                    value={this.state.chatroomType}
                    options={this.props.chatroomTypes}
                    onChange={this.handlerChangeChatroomType}
                    skipSelect={true}
                    styles={{
                      placeholder: (base) => ({
                        ...base,
                        color: "#555",
                      }),
                    }}
                  />
                  <p>{this.chatroomNote()}</p>
                </div>
              )}
              {this.isUserChatroom() && userOptions ? (
              <div>
                <label htmlFor="chat-modal-select-employees" className="sr-only">
                Employees
                </label>
                <FormSelect
                  _key="id"
                  _val="full_name"
                  label="Employees"
                  name="users"
                  selectId="chat-modal-select-employees"
                  required={false}
                  selectProps={{isMulti: true}}
                  errors={errors.user_ids}
                  value={users}
                  dataValue={users}
                  options={userOptions}
                  urlSearch={"/api/v1/employees.json?search={q}&method=full_name&limit=50&digichat_access=true&without_current_user=true"}
                  onChange={this.handlerChangeUsers}
                  styles={{
                    menuPortal: provided => ({ ...provided, zIndex: 9999 }),
                    placeholder: (base) => ({
                      ...base,
                      color: "#555",
                    }),
                  }}
                  menuPortalTarget={document.body}
                />
              </div>
              ) : null}

              {this.props.newChatroom && this.isLocationChatroom() && locationOptions ? (
                <div>
                   <label htmlFor="chat-modal-select-locations" className="sr-only">
                    Locations
                   </label>
                <FormSelect
                  _key="id"
                  _val="name"
                  label="Location"
                  name="locations"
                  selectId="chat-modal-select-locations"
                  required={false}
                  selectProps={{isMulti: false}}
                  errors={errors.location_id}
                  value={this.state.locationId}
                  options={locationOptions}
                  onChange={this.handlerChangeLocation}
                  styles={{
                    placeholder: (base) => ({
                      ...base,
                      color: "#555",
                    }),
                  }}
                />
                </div>
              ) : null}

              {this.props.newChatroom && this.isPositionChatroom() && positionOptions ? (
                <div>
                  <label htmlFor="chat-modal-select-positions" className="sr-only">
                    Positions
                  </label>
                <FormSelect
                  _key="id"
                  _val="name"
                  label="Position"
                  selectId="chat-modal-select-positions"
                  name="position"
                  required={false}
                  selectProps={{isMulti: false}}
                  errors={errors.position_id}
                  value={this.state.positionId}
                  options={positionOptions}
                  onChange={this.handlerChangePosition}
                  styles={{
                    placeholder: (base) => ({
                      ...base,
                      color: "#555",
                    }),
                  }}
                />
                </div>
              ) : null}

              <br />
              <div className="form-divider"/>
              <br />

              <div>
                <button
                  type="submit"
                  className={classNames("btn btn-block btn-pink", {
                    disabled: this.state.loading
                  })}
                >
                  {this.props.newChatroom ?
                    "CREATE" : "UPDATE"
                  }
                </button>
              </div>
            </form>
          </div>
        </Modal>
      </div>
    );
  }

  handlerChangeUsers = (users) => {
    this.setState({
      users: users,
      loading: false,
      errors: {}
    });
  };

  handlerChangeLocation = (e) => {
    this.setState({
      locationId: e.target.value,
      loading: false,
      errors: {}
    });
  };

  handlerChangePosition = (e) => {
    this.setState({
      positionId: e.target.value,
      loading: false,
      errors: {}
    });
  };

  handlerChangeTitle = (e) => {
    this.setState({
      title: e.target.value,
      loading: false,
      errors: {}
    });
  };

  handlerChangeChatroomType = (e) => {
    this.setState({
      chatroomType: e.target.value,
      errors: {},
      users: [],
      loading: false
    });
  };

  handlerChangeRepliesEnabled = (e) => {
    this.setState({
      repliesEnabled: e.target.value,
      errors: {},
      loading: false
    });
  };

  resetDefaults = () => {
    this.setState({
      errors: {},
      users: [],
      title: "",
      locationId: null,
      positionId: null,
      chatroomType: 0,
      loading: false,
      repliesEnabled: true
    });
  }

  isUserChatroom = () => this.state.chatroomType == 0;
  isLocationChatroom = () => this.state.chatroomType == 1;
  isPositionChatroom = () => this.state.chatroomType == 2;

  chatroomNote = () => {
    switch(parseInt(this.state.chatroomType)) {
      case 0:
        return 'Add Employees to the chatroom below.';
      case 1:
        return 'All Employees in the selected Location will have access to the chatroom.  Employees added or removed from the location will automatically be added and removed from the chatroom.';
      case 2:
        return 'All Employees for the selected Position will have access to the chatroom.  Employees who have this position added or removed from their profile will automatically be added and removed from the chatroom.';
      case 3:
        return 'All Employees at a Location will be automatically added to the chatroom.';
    }
  }

  chatroomSubTitle = () => {
    if (this.props.newChatroom) {
      return null
    } else {
      return `created by ${this.props.chatroom.creator_name} on ${moment(this.props.chatroom.created_at).format(DATETIME)}`
    };
  };


  submit = (e) => {
    e.preventDefault();

    if(this.state.loading) { return; }

    if (this.state.title == "") {
      this.setState({
        errors: {
          title: ["Please enter a title."]
        }
      })
      return;
    };

    if (this.state.chatroomType == 0 && this.state.users.length == 0) {
      this.setState({
        errors: {
          user_ids: ["Please choose at least one Employee."]
        }
      })
      return;
    };

    this.setState({loading: true});

    let user_ids = this.state.users.map((user) => String(user.value));

    if (this.props.newChatroom) {
      user_ids.push(String(this.props.currentUser.id));
    }
    user_ids = Array.from(new Set(user_ids));

    const data = this.props.newChatroom ? {
      chatroom: {
        title: this.state.title,
        chatroom_type: this.state.chatroomType,
        user_ids: this.isUserChatroom() ? user_ids : [],
        location_id: this.isLocationChatroom() ? this.state.locationId : null,
        position_id: this.isPositionChatroom() ? this.state.positionId : null,
        replies_enabled: this.state.repliesEnabled
      }
    } : {
      chatroom: {
        title: this.state.title,
        user_ids: user_ids,
        replies_enabled: this.state.repliesEnabled
      }
    };

    const request = this.props.newChatroom
      ? axios.post(
          "/chatrooms",
          data
        )
      : axios.put(
          `/chatrooms/${this.props.chatroom.id}`,
          data
        );

    request.then(({data}) => {
      if (this.props.newChatroom) {
        toastr.success("Chatroom Created");
        this.props.addChatroom(data);
      } else {
        toastr.success("Chatroom Updated");
        this.props.updateChatroom(data);
      };
      this.props.handlerToggleModal();
      this.resetDefaults();
    })
    .catch((error) => {
      this.setState({loading: false}, () => {
        if (error.response && error.response.data.errors) {
          this.setState({errors: error.response.data.errors});
        }
      });
    })
  };
}

ChatroomFormModal.propTypes = {
  addChatroom: PropTypes.func
};

export default ChatroomFormModal;
